import React, { useCallback } from "react";
import classNames from "classnames/dedupe";
import { IDropdownOptionProps } from "../DropdownOption";
import { useTheme } from "../../../Utility/ThemeProvider";
import { TSelectorOption } from "../Select";

export function SelectOption<ItemType = TSelectorOption>({
  item,
  classes,
  valueKey,
  variant,
  children,
  onSelect,
}: IDropdownOptionProps<ItemType>) {
  const theme = useTheme(variant);

  const handleOptionClick = useCallback(() => {
    onSelect && onSelect(item[valueKey]);
  }, [item, onSelect, valueKey]);

  return (
    <div
      className={classNames(
        "dropdown-option dropdown-option--selector-option h-menu-medium",
        {
          "dropdown-option--dark": theme === "dark",
        },
        classes?.root,
      )}
      data-testid="SelectOption"
      onClick={handleOptionClick}
    >
      {children}
    </div>
  );
}
